import styled, { css } from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const Control = styled.button`
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  transition: 0.3s ease-out;
  text-align: left;

  &:disabled {
    color var(--p-neutral-450);
  }

  &:hover:disabled {
    color: var(--p-neutral-450);
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 10px;
  }

  ${(p) =>
    p.active &&
    css`
      color: var(--p-pink-480);
    }
      &:hover{
        opacity: .6;
      `}

  ${(p) =>
    p.theme === 'base' &&
    css`
      color: var(--t-link-color);

      &:hover {
        color: var(--t-link-hover);
      }
    `}

  ${(p) =>
    p.theme === 'edit' &&
    css`
      color: var(--p-neutral-550);

      &:hover {
        color: var(--p-blue-400);
      }
    `}

  ${(p) =>
    p.theme === 'grey' &&
    css`
      color: var(--p-neutral-550);

      &:hover {
        color: var(--t-button-control-grey-hover);
      }
    `}
`
